<template>
  <div :class="['info-sections', { 'is-visible': isActive }]">
    <ul class="info-sections__tabs">
      <li :class="['info-sections__tab', { active: isActive }]">
        <button class="info-sections__tab-button" @click="toggleVisibility">
          <span v-if="svg" class="info-sections__tab-svg" v-html="svg"></span>
          <span class="info-sections__tab-title"> {{ title }}</span>
          <span v-if="subtitle" class="info-sections__tab-subtitle">
            {{ subtitle }}
          </span>
          <span
            v-if="subtotal"
            :class="['info-sections__tab-price', { active: !isActive }]"
          >
            ({{
              $isGlobalStore ? subtotalValue : formatPrice(subtotalValue)
            }})</span
          >
          <icon-chevron-down class="info-sections__arrow" />
        </button>
        <div class="info-sections__tab-content">
          <div v-if="description" class="info-sections__tab-description">
            {{ description }}
          </div>
          <slot></slot>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import IconChevronDown from '~/components/icons/chevron-down/ChevronDownIcon'
import priceable from '~/mixins/priceable'

export default {
  components: {
    IconChevronDown,
  },
  mixins: [priceable],
  props: {
    title: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: String,
      default: null,
      required: false,
    },
    description: {
      type: String,
      default: null,
      required: false,
    },
    svg: {
      type: String,
      default: null,
      required: false,
    },
    subtotal: {
      type: [String, Number],
      default: null,
      required: false,
    },
  },
  data() {
    return {
      isActive: this.isVisible,
    }
  },
  computed: {
    subtotalValue() {
      return this.subtotal
    },
  },
  methods: {
    toggleVisibility() {
      this.isActive = !this.isActive
    },
  },
}
</script>

<style lang="scss">
.info-sections {
  padding: 0 18px;
  border-bottom: 1px solid #e6e6ea;
  line-height: normal;
  width: 100%;

  .info-sections__tab-button {
    display: block;
    position: relative;
    align-items: center;
    width: 100%;
    text-align: left;
    cursor: pointer;
    border-radius: 0;
    background-color: transparent;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: transparent;
    padding: 10px 0 10px 0;

    &:focus {
      outline: 0;
    }

    .info-sections__tab-price {
      color: $v4_color_primary;
      display: none;
    }

    .info-sections__tab-price.active {
      display: inline-block;
    }

    .info-sections__tab-svg {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }

    .info-sections__arrow {
      position: absolute;
      top: 50%;
      right: 1px;
      width: 20px;
      margin-top: -9px;
      fill: #a2a2a6;
      transition: transform 200ms ease-in-out;
    }

    .info-sections__tab-title {
      font-size: 15px;
      color: #555;
      width: 40%;
    }

    .info-sections__tab-subtitle {
      font-size: 13px;
      color: $v4_color_primary;
      width: 40%;
    }
  }

  .info-sections__tab-description {
    font-size: 13px !important;
    color: #a2a2a6;
    font-size: 13px;
    width: 100%;
    margin: 0;
    padding: 0 0 16px 0;
  }

  .info-sections__tab-content {
    display: none;
    transition: opacity 0.3s ease;
    padding-bottom: 10px;
    font-size: 14px;
    line-height: 1.4;
    border-bottom: 1px solid $v4_color_line_lighter;
    color: #525256;
  }

  .info-sections__tab.active {
    .info-sections__arrow {
      transform: rotate(180deg) translateY(3px) translateX(3px);
    }
    .info-sections__tab-content {
      display: block;
      opacity: 1;
    }
  }

  .is-visible {
    .info-sections__tab.active {
      .info-sections__arrow {
        transform: rotate(0);
      }
      .info-sections__tab-content {
        display: none;
      }
    }
  }
}

@media (min-width: $v4_desktop) {
  html .info-sections {
    .info-sections__tabs {
    }

    .info-sections__tab--mobile {
    }

    .info-sections__tab-button,
    .info-sections__tab-content {
    }

    .info-sections__tabs li:first-child .info-sections__tab-title {
    }

    .info-sections__tab-button {
    }

    .info-sections__tab-content {
    }
  }
}
</style>
